import { useState, useMemo } from "react";
import { Chart } from "primereact/chart";
import { Dropdown } from "primereact/dropdown";

const OverallCollectionChart = ({ monthsList, dashboardData }) => {
  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const monthIndex = selectedMonth - 1;

  const overallCollections = useMemo(() => {
    return (dashboardData?.overallCollections || []).filter((entry) => {
      const entryDate = new Date(entry.date);
      return (
        entryDate.getMonth() === monthIndex &&
        entryDate.getFullYear() === currentYear
      );
    });
  }, [dashboardData, monthIndex, currentYear]);

  const weeks = useMemo(() => {
    let tempWeeks = [];
    let startDate = new Date(currentYear, monthIndex, 1);

    while (startDate.getMonth() === monthIndex) {
      let endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      if (endDate.getMonth() !== monthIndex) {
        endDate = new Date(currentYear, monthIndex + 1, 0);
      }
      tempWeeks.push(
        `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
      );
      startDate.setDate(startDate.getDate() + 7);
    }
    return tempWeeks;
  }, [monthIndex, currentYear]);

  const chartData = {
    labels: overallCollections.map((entry) => entry.day),
    datasets: [
      {
        type: "bar",
        label: "Transactions",
        data: overallCollections.map((entry) => entry.transactions),
        backgroundColor: "#669FD3",
        yAxisID: "y-left",
      },
      {
        type: "line",
        label: "Collection (PKR)",
        data: overallCollections.map((entry) => entry.collections),
        borderColor: "#FF5722",
        borderWidth: 2,
        fill: false,
        yAxisID: "y-right",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
    scales: {
      "y-left": {
        type: "linear",
        position: "left",
        title: { display: true, text: "Transactions" },
        beginAtZero: true,
        ticks: {
          stepSize: 2000,
        },
      },
      "y-right": {
        type: "linear",
        position: "right",
        title: { display: true, text: "Collection (PKR)" },
        beginAtZero: true,
        ticks: {
          stepSize: 2000000,
        },
      },
    },
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <h3 className="text-xl font-bold text-lg">
          Overall Collection ({currentYear})
        </h3>
        <Dropdown
          value={selectedMonth}
          options={monthsList}
          onChange={(e) => setSelectedMonth(e.value)}
          placeholder="Select Month"
          optionLabel="label"
          filter
        />
      </div>

      <Chart
        type="bar"
        data={chartData}
        options={chartOptions}
        style={{ height: "400px" }}
      />

      <div className="text-center mt-2 text-sm font-semibold">
        {weeks.map((week, index) => (
          <span key={index} className="mr-6">
            Week {index + 1} - {week}
          </span>
        ))}
      </div>
    </>
  );
};

export default OverallCollectionChart;
